import React from 'react';

export const PennsylvaniaInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of Pennsylvania</p>
        <p className="eds-l-mar-bot-1">
            <strong>Small Business First Fund</strong> |&nbsp;
            <a
                href="https://dced.pa.gov/programs/pennsylvania-industrial-development-authority-pida/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Working capital loans of up to $100,000 directly to small businesses
            & hopefully nonprofits with 3% current interest rate.
        </p>

        <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
            City of Philadelphia
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Grants and Zero-Interest Loans</strong> |&nbsp;
            <a
                href="https://6abc.com/6018429/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            New grants and zero-interest loans for Philadelphia businesses that
            make under $5 million in annual revenue.
        </p>

        <p className="eds-l-mar-bot-1 eds-l-mar-top-4">
            <strong>Small Business Relief Fund</strong> |&nbsp;
            <a
                href="https://phila-uyims.formstack.com/forms/philadelphia_covid_19_small_business_relief_fund"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>3 relief programs, one application:</p>
        <ul>
            <li>
                Microenterprise Grants - $5,000 per business for businesses with
                less than $500,000 in annual revenue.
            </li>
            <li>
                Small Business Grants - up to $25,000 per business for
                businesses with annual revenue between $500,000 & $3 million.
            </li>
            <li>
                Small Business Zero-Interest Loan - up to $100,000 per business
                for businesses with annual revenue between $3 million & $5
                million.
            </li>
        </ul>
    </div>
);
